import { render, staticRenderFns } from "./SharedMediaMediaPackageChangeActivationType.vue?vue&type=template&id=b5aeddf4&"
import script from "./SharedMediaMediaPackageChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./SharedMediaMediaPackageChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports